<template>
    <div>
        <el-menu-item v-if="!obj.smenuList || obj.smenuList.length===0" :index="obj.vc_url" >{{obj.vc_name}}
        </el-menu-item>
        <div v-else>
            <el-submenu :index="obj.vc_url">
                <template slot="title">{{obj.vc_name}}
                </template>
                <menu-item v-for="(item,index) in obj.smenuList" :key="index" :obj="item"></menu-item>
            </el-submenu>
        </div>
    </div>
</template>
<script>
    import MenuItem from "./MenuItem";
    export default {
        name: 'MenuItem',
        components:{MenuItem},
        props:{
            obj:Object,
        },
        data(){
            return{
            }

        },
    }
</script>
<style  lang="scss" scoped>
/deep/{
    .el-submenu .el-menu-item{
        padding: 0 20px;
    }
    .el-menu-item, .el-submenu__title{
        height: 34px;
        line-height: 34px;
    }
}

</style>